import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText, Music, Play } from "lucide-react";
import api from "../lib/api";
import { RetryImg } from "./RetryImg";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Thumb = ({ item }) => {
  const src = `${BACKEND}${item.url}`;
  if (item.kind === "image")
    return <RetryImg src={`${BACKEND}/api/letters/thumb/${item.id}`} fallback={src} alt={item.caption || item.filename} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />;
  if (item.kind === "video")
    return (
      <div className="relative h-full w-full bg-black">
        <video src={`${src}#t=0.5`} preload="metadata" muted playsInline className="h-full w-full object-cover" />
        <Play className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 fill-white/80 text-white/80" />
      </div>
    );
  const Icon = item.kind === "audio" ? Music : FileText;
  return (
    <div className="flex h-full w-full items-center justify-center bg-[#1f1f1f]">
      <Icon className="h-12 w-12 text-[#e0a82e]" />
    </div>
  );
};

const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "";

const LatestUploads = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/letters/uploads", { params: { limit: 3 } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section data-testid="latest-uploads-section" className="relative z-10 mx-auto max-w-6xl px-4 pt-12 md:px-8 md:pt-16">
      <div className="mb-6 flex items-end justify-between gap-4">
        <h2 className="font-display text-2xl uppercase tracking-wide text-[#e0a82e] md:text-3xl">Latest Uploads</h2>
        <Link to="/your-story" data-testid="latest-uploads-view-all" className="flex items-center gap-1 font-display text-sm uppercase tracking-wide text-[#e0574c] transition-colors hover:text-[#f2b93f]">
          View all <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="grid gap-6 sm:grid-cols-3">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/your-story#upload-${item.id}`}
            data-testid={`latest-upload-tile-${item.id}`}
            className="group overflow-hidden rounded-md border border-white/10 bg-[#2a2a2a] shadow-xl transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="h-44 overflow-hidden"><Thumb item={item} /></div>
            <div className="px-4 py-3">
              <p className="truncate font-display text-base uppercase tracking-wide text-white">{item.uploaderName || "Member"}</p>
              <p className="text-xs text-[#9a9a9a]">{formatDate(item.createdAt)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default LatestUploads;
